import { findGrapesJSComponent } from '../../../domUtils';
import { isEmpty } from '../../../utils';

const buttonsSvg = {
	drag: `<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M22.67,12L18.18,16.5L15.67,14L17.65,12L15.67,10.04L18.18,7.53L22.67,12M12,1.33L16.47,5.82L13.96,8.33L12,6.35L10,8.33L7.5,5.82L12,1.33M12,22.67L7.53,18.18L10.04,15.67L12,17.65L14,15.67L16.5,18.18L12,22.67M1.33,12L5.82,7.5L8.33,10L6.35,12L8.33,13.96L5.82,16.47L1.33,12M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10Z" /></svg>`,
	delete: `<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z" /></svg>`,
	clone: `<svg width="22" height="22"><path fill="currentColor" d="M20.43 20.035V6.68c0-.11-.04-.2-.117-.278a.381.381 0 0 0-.278-.117H6.68c-.11 0-.2.04-.278.117a.375.375 0 0 0-.117.278v13.355c0 .106.04.2.117.277a.375.375 0 0 0 .278.118h13.355c.106 0 .2-.04.277-.117a.381.381 0 0 0 .118-.278zM22 6.68v13.355c0 .54-.191 1.004-.578 1.387a1.882 1.882 0 0 1-1.387.578H6.68a1.876 1.876 0 0 1-1.387-.578 1.882 1.882 0 0 1-.578-1.387V6.68c0-.543.191-1.004.578-1.387a1.876 1.876 0 0 1 1.387-.578h13.355c.54 0 1.004.191 1.387.578.387.383.578.844.578 1.387zm-4.715-4.715V3.93h-1.57V1.965c0-.106-.04-.2-.117-.278a.375.375 0 0 0-.278-.117H1.965c-.106 0-.2.04-.278.117a.381.381 0 0 0-.117.278V15.32c0 .11.04.2.117.278a.381.381 0 0 0 .278.117H3.93v1.57H1.965c-.54 0-1.004-.191-1.387-.578A1.876 1.876 0 0 1 0 15.32V1.965C0 1.425.191.96.578.578A1.882 1.882 0 0 1 1.965 0H15.32c.543 0 1.004.191 1.387.578.387.383.578.848.578 1.387zm0 0"/></svg>`,
};

const buttonsCallback = {
	drag: ({ el, editor }, event, sectionName) => {
		const component = findGrapesJSComponent(`#${el.id}`);
		let wrapper;
		if (sectionName === 'services') {
			wrapper = 'services-wrapper';
		} else if (sectionName === 'accolades') {
			wrapper = 'accolades-wrapper';
		}
		component.set('draggable', `div[class*="${wrapper}"]`);
		editor.runCommand('tlb-move', {
			target: component,
			event,
		});
	},
	delete:
		({ el }) =>
		() => {
			const component = findGrapesJSComponent(`#${el.id}`);
			if (component) {
				component.remove();
			}
		},
	clone:
		({ model }) =>
		() => {
			const parent = model.parent();
			// console.log('ServiceItemComponent handleEventCallback', parent);
			// console.log('ServiceItemComponent btnCloneCallback', model);
			// console.log('ServiceItemComponent btnCloneCallback index', model.index());

			const newlyAdded = model.clone();
			parent.components().add(newlyAdded, { at: model.index() + 1 });

			// const component = findGrapesJSComponent(`#${el.id}`);
			// editor.select(el);
			// editor.runCommand('core:copy');
			// editor.runCommand('core:paste');
		},
};

const generateButton = (props, buttonCallBack, svg, eventListenerObj) => {
	// console.log('generateButton', props);
	const btn = document.createElement('button');
	btn.innerHTML = svg;
	btn.classList.add('editor-button', 'icon-button', 'delete-button');

	if (eventListenerObj && !isEmpty(eventListenerObj)) {
		const { eventName, sectionName } = eventListenerObj;
		btn.addEventListener(eventName, (event) => buttonCallBack(props, event, sectionName));
	} else {
		btn.addEventListener('click', buttonCallBack(props));
		btn.addEventListener('touchstart', buttonCallBack(props));
	}
	return btn;
};

export const generateButtonDrag = (props, sectionName) => {
	return generateButton(props, buttonsCallback.drag, buttonsSvg.drag, {
		eventName: 'mousedown',
		sectionName,
	});
};
export const generateButtonDelete = (props) => {
	return generateButton(props, buttonsCallback.delete, buttonsSvg.delete);
};
export const generateButtonClone = (props) => {
	return generateButton(props, buttonsCallback.clone, buttonsSvg.clone);
};
